import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import _ from 'lodash'

import './style.scss'

export default class Counter extends Component {
    static propTypes = {
        customClassName: PropTypes.string,
        description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        leftValue: PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.element]),
            style: PropTypes.object,
        }),
        rightValue: PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.element]),
            style: PropTypes.object,
        }),
        separator: PropTypes.string,
        separatorStyle: PropTypes.object,
        twoValues: PropTypes.bool,
    }

    static defaultProps = {
        separator: '/',
        twoValues: false,
    }

    render() {
        const { leftValue, rightValue, twoValues, separator, separatorStyle, customClassName, description } = this.props

        return (
            <div className={cx('global-counter-component', customClassName)}>
                <div className={'counter-row'}>
                    <div className={'values-container'}>
                        <div className={'left-value-wrapper'} style={{ ..._.get(leftValue, 'style', {}) }}>
                            {!_.isNil(_.get(leftValue, 'value')) ? leftValue.value : 0}
                        </div>
                        {twoValues && (
                            <div className={'separator-wrapper'} style={{ ...separatorStyle }}>
                                {separator}
                            </div>
                        )}
                        {twoValues && (
                            <div className={'right-value-wrapper'} style={{ ..._.get(rightValue, 'style', {}) }}>
                                {!_.isNil(_.get(rightValue, 'value')) ? rightValue.value : 0}
                            </div>
                        )}
                    </div>
                    <div className={'desc-container'}>
                        <div className={'desc-wrapper'}>{description}</div>
                    </div>
                </div>
            </div>
        )
    }
}
